import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const InputField = ({ label, id, type, value, onChange, placeholder }) => (
  <div className="mb-3">
    <label htmlFor={id} className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
      {label}
    </label>
    <input
      type={type}
      id={id}
      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required
    />
  </div>
);

export default function SignIn() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const requestBody = { login, password };

    try {
      const response = await fetch('https://staging-sit.com/api/auth/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
        credentials: 'include',
      });

      const responseData = await response.json();

      if (!response.ok) {
        if (responseData.non_field_errors) {
          throw new Error(responseData.non_field_errors[0]);
        } else if (responseData.login) {
          throw new Error(responseData.login[0]);
        } else if (responseData.password) {
          throw new Error(responseData.password[0]);
        } else {
          throw new Error('An unexpected error occurred. Please try again.');
        }
      }

      localStorage.setItem('authToken', responseData.token);
      localStorage.setItem('user', JSON.stringify(responseData.user));
      
      navigate('/admin/default');
    } catch (err) {
      console.error("Error during sign in:", err);
      setError(err.message || "Login failed. Please check your credentials and try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your Email/ Username and password to sign in.
        </p>
        <form onSubmit={handleSignIn}>
          <InputField
            label="Email/ Username"
            id="login"
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            placeholder="Your Email/ Username"
          />
          <InputField
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
          />
          {error && (
            <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
              <p className="text-sm">{error}</p>
            </div>
          )}
          <button 
            type="submit" 
            className={`linear mt-2 w-full rounded-xl py-[12px] text-base font-medium text-white transition duration-200 
              ${isLoading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200'
              }`}
            disabled={isLoading}
          >
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}